var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20868_21771",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20.9893,
    height: 20.9893,
    transform: "matrix(-1 0 0 1 21.251 0.00537109)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20868_21771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7568 18.8073C11.7883 18.8073 12.7548 18.6122 13.6562 18.222C14.5577 17.8318 15.3437 17.3015 16.0141 16.631C16.6846 15.9605 17.215 15.1745 17.6051 14.2731C17.9953 13.3716 18.1904 12.4051 18.1904 11.3736C18.1904 10.3421 17.9953 9.37561 17.6051 8.47415C17.215 7.57269 16.6846 6.78671 16.0141 6.11622C15.3437 5.44575 14.5577 4.91542 13.6562 4.52524C12.7548 4.13504 11.7883 3.93994 10.7568 3.93994H10.5246L11.4699 2.99475C11.5966 2.86805 11.6599 2.71669 11.6599 2.54066C11.6599 2.36464 11.5966 2.20879 11.4699 2.07312C11.3398 1.94306 11.1854 1.87579 11.0065 1.87132C10.8277 1.86683 10.6705 1.92961 10.5348 2.05967L8.55192 4.03413C8.40279 4.18324 8.32823 4.36768 8.32823 4.58744C8.32823 4.8072 8.40279 4.99164 8.55192 5.14077L10.518 7.1152C10.648 7.25087 10.8025 7.31646 10.9813 7.31197C11.1601 7.30749 11.3174 7.23741 11.453 7.10175C11.5797 6.96608 11.6431 6.81024 11.6431 6.63422C11.6431 6.45819 11.5797 6.30682 11.453 6.18013L10.5246 5.25175H10.7568C12.4621 5.25175 13.9088 5.84571 15.0967 7.03365C16.2847 8.22158 16.8786 9.66824 16.8786 11.3736C16.8786 13.079 16.2847 14.5256 15.0967 15.7136C13.9088 16.9015 12.4621 17.4955 10.7568 17.4955C9.17807 17.4955 7.81017 16.9716 6.65307 15.9238C5.49598 14.876 4.83502 13.5673 4.6702 11.9976C4.64666 11.8204 4.56986 11.6721 4.4398 11.5527C4.30973 11.4333 4.15613 11.3736 3.97899 11.3736C3.80184 11.3736 3.64823 11.4311 3.51817 11.546C3.38811 11.6609 3.33205 11.8025 3.34999 11.9707C3.50921 13.9126 4.29574 15.5375 5.7096 16.8454C7.12345 18.1533 8.80583 18.8073 10.7568 18.8073Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.94ea662518e258c1371ddf66dc525db9.svg";
export { ForwardRef as ReactComponent };